import { useUploadPolygonMutation } from 'app/api';
import { selectSelectedCompanyId } from 'app/containers/Company/slice/selectors';
import { selectSelectedEnvId } from 'app/containers/HiikoEnv/slice/selectors';
import { selectSelectedSeasonId } from 'app/containers/Season/slice/selectors';
import { RouteConstants } from 'app/routes';
import { useSelector } from 'react-redux';
import { generatePath, useHistory } from 'react-router-dom';
import { showPolygonsUploadSuccessNotification } from 'utils/notifications';
import { showSelectAtLeast1FieldWarningNotification } from '../notifications';
import { selectDrawnPolygonsArr } from '../../app/containers/Field/slice/selectors';
import {
  IUploadPolygonData,
  PolygonLatLngTupleType,
} from '../../app/containers/Field/slice/types';
import * as L from 'leaflet';
import { handleError } from 'app/containers/Global/slice/helpers';

const useUploadDrawnPolygons = () => {
  const history = useHistory();

  const [uploadPolygon] = useUploadPolygonMutation();

  const seasonId = useSelector(selectSelectedSeasonId) as number;
  const envId = useSelector(selectSelectedEnvId) as number;
  const companyId = useSelector(selectSelectedCompanyId) as number;
  const drawnPolygons = useSelector(selectDrawnPolygonsArr);

  const onSubmit = async (values: { [key: string]: string }) => {
    try {
      const fieldIdsNamesObj = values;

      const drawnFieldsDatas: IUploadPolygonData[] = [];

      for (let [id, name] of Object.entries(fieldIdsNamesObj)) {
        const thePolygon = drawnPolygons.find(polygon => polygon.id === id);
        if (thePolygon) {
          const polygonGeoJSON = L.polygon(thePolygon.latlngs)?.toGeoJSON();
          const coordinatesFromGeoJSON = ([
            polygonGeoJSON.geometry.coordinates,
          ] as unknown) as PolygonLatLngTupleType;

          const data: IUploadPolygonData = {
            geometryInfo: {
              type: 'MULTIPOLYGON',
              coordinates: coordinatesFromGeoJSON,
            },
            fieldName: name,
            companyId,
            seasonId,
          };
          drawnFieldsDatas.push(data);
        }
      }

      if (!drawnFieldsDatas.length) {
        showSelectAtLeast1FieldWarningNotification();
        return;
      }

      await Promise.all(
        drawnFieldsDatas.map(payload =>
          uploadPolygon({ envId, data: payload }).unwrap(),
        ),
      );
      history.push(
        generatePath(RouteConstants.field.list, {
          envId,
        }),
      );

      showPolygonsUploadSuccessNotification();
    } catch (error) {
      if (error?.status !== 500) {
        handleError(error);
      }
    }
  };

  return { onSubmit };
};

export default useUploadDrawnPolygons;
